import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { PublicProfile } from "../publicProfile.types";

/**
 * Arguments for useFetchPublicProfile hook.
 */
export type UseFetchPublicProfileArgs = {
  /** User ID to fetch profile for */
  userId: number | null;
  /** Program ID to scope the profile to */
  programId: number | undefined;
  /** Whether the query is enabled */
  isEnabled?: boolean;
};

/**
 * Hook to fetch another user's public profile.
 * Returns React Query result with PublicProfile data.
 */
export function useFetchPublicProfile({
  userId,
  programId,
  isEnabled = true,
}: UseFetchPublicProfileArgs) {
  return useQuery<PublicProfile, Error>({
    queryKey: ["public-profile", userId, programId],
    queryFn: async () => {
      const params = programId ? `?program_id=${programId}` : "";
      return (await apiRequest(
        `/profile/${userId}/${params}`,
        "GET"
      )) as PublicProfile;
    },
    enabled: !!userId && isEnabled,
  });
}

export default useFetchPublicProfile;
